import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { AccountantSignUpDto } from '../../_dto/_accountant/AccountantSignUpDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiSignUpAccountant = async (dto: AccountantSignUpDto) => {
  const params: IApiParams = {
    url: '/accountant/signUp.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
